module.exports = __webpack_public_path__ + "media/images/flags/1x1/egy-4c910ed27e0b3a56791e58ba0721ab56.svg";